import screenshotImage from '../../assets/images/my-properties-screenshot.png';
import CustomTooltip from './customTooltip';

const registerSteps = [
  {
    id: 'click-register',
    content: (
      <>
        1. Click the "<i>Register for Notification</i>" button.
      </>
    ),
  },
  {
    id: 'sign-in',
    content: <>2. Create an account or log into the Public Portal.</>,
  },
  {
    id: 'open-my-properties',
    content: (
      <>
        3. Go to the "<i>My Properties</i>" page.
      </>
    ),
  },
  {
    id: 'check-receive-update',
    content: (
      <>
        4. Locate the "<i>Receive Update</i>" column and click the checkbox.
      </>
    ),
  },
];

const notificationConditions = [
  '- Market value change on the property.',
  '- Taxable value change on the property.',
  '- Taxing unit tax rate change.',
  '- Taxing unit hearing notice (added/removed/deleted).',
];

const registerInstructions = (
  <div
    style={{
      maxWidth: '690px',
      padding: '6px 20px',
      fontSize: '14px',
      backgroundColor: '#2f2f2f',
    }}
  >
    <div style={{ color: '#deef6e', fontWeight: 'bold' }}>HOW TO REGISTER</div>
    {registerSteps.map(({ id, content }) => (
      <div key={id}>{content}</div>
    ))}
    <img
      alt='My Properties registration screenshot'
      src={screenshotImage}
      style={{ width: '350px' }}
    />
    <div style={{ fontWeight: 'bold' }}>
      We will generate an email notice under the following conditions:
    </div>
    {notificationConditions.map((condition) => (
      <div key={condition}>{condition}</div>
    ))}
  </div>
);

const RegisterNotificationTooltip = ({ children }) => (
  <CustomTooltip
    arrow
    className='tooltip-info-content'
    content={registerInstructions}
    placement='bottom'
    variant='dark'
  >
    {children}
  </CustomTooltip>
);

export default RegisterNotificationTooltip;
